import Grid from 'components/Custom/Grid';
import { SysUser } from 'classes';
import { getSysUsers } from 'utils/SysUserUtils';
import { useAppContext } from 'hooks/useAppContext';


const ModifyUserGrid = () => {
    const formPath = () => import('./ModifyUserForm');
    const { selectedProject } = useAppContext();

    return (
        <Grid
            title="Modify User"
            columns={SysUser.columns}
            getRecords={getSysUsers}
            formPath={formPath}
            enable={{
                edit: true,
                delete: false
            }}
            options={{
                pageSize: 10,
                pageSizeOption: [10, 20, 25]
            }}
            component="AdminConfig"
            selectedProject={selectedProject}
        />
    )
}

export default ModifyUserGrid;